import { useEffect } from 'react';
import {
  createRootRoute,
  createRoute,
  createRouter,
  useNavigate,
} from '@tanstack/react-router';
import { Permission } from '@kolectra/shared/permissions';
import { AppShell } from './app-shell.js';
import { CreationPage } from './routes/creation.js';
import { JudgementPage } from './routes/judgement.js';
import { TeamPage } from './routes/team.js';
import { TeamDashboardPage } from './routes/dashboard.js';
import { HleDashboardPage } from './routes/hle-dashboard.js';
import { HleConfigPage } from './routes/hle-config.js';
import { useWebPerms } from './auth.js';

const rootRoute = createRootRoute({ component: AppShell });

/** Land on the first section the current role can use. */
function IndexRedirect() {
  const perms = useWebPerms();
  const navigate = useNavigate();
  useEffect(() => {
    if (perms.has(Permission.CAN_DESIGN) || perms.has(Permission.CAN_IMPORT_CSV)) {
      void navigate({ to: '/creation' });
    } else if (perms.has(Permission.CAN_JUDGE)) {
      void navigate({ to: '/judgement' });
    } else if (perms.has(Permission.CAN_MANAGE_TEAM)) {
      void navigate({ to: '/team' });
    } else if (perms.has(Permission.CAN_VIEW_DASHBOARD)) {
      void navigate({ to: '/dashboard' });
    } else if (perms.has(Permission.CAN_MANAGE_PROJECT)) {
      void navigate({ to: '/hle' });
    }
  }, [perms, navigate]);
  return null;
}

const indexRoute = createRoute({ getParentRoute: () => rootRoute, path: '/', component: IndexRedirect });
const creationRoute = createRoute({ getParentRoute: () => rootRoute, path: '/creation', component: CreationPage });
const judgementRoute = createRoute({ getParentRoute: () => rootRoute, path: '/judgement', component: JudgementPage });
const teamRoute = createRoute({ getParentRoute: () => rootRoute, path: '/team', component: TeamPage });
const dashboardRoute = createRoute({ getParentRoute: () => rootRoute, path: '/dashboard', component: TeamDashboardPage });
const hleDashboardRoute = createRoute({ getParentRoute: () => rootRoute, path: '/hle', component: HleDashboardPage });
const hleConfigRoute = createRoute({ getParentRoute: () => rootRoute, path: '/hle/config', component: HleConfigPage });

const routeTree = rootRoute.addChildren([indexRoute, creationRoute, judgementRoute, teamRoute, dashboardRoute, hleDashboardRoute, hleConfigRoute]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
